module.exports = __webpack_public_path__ + "assets/72a5a65168026ae5fb2473eeda24b051.mp3";